import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bstoast',
	templateUrl:'./BSToastPluginCompPage.html',
	styles: [],
	styleUrls:['./BSToastPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSToastPluginCompPage
{
	mdContent_874 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.toasts.BSToast;
\`\`\``;
	mdContent_875 = `\`\`\`java
BSToast()
\`\`\``;
	mdContent_876 = `\`\`\`java
BSToast&lt;?&gt; toast = new BSToast&lt;&gt;();
toast.setHeader("Notification");
toast.add(new Paragraph&lt;&gt;().setText("Operation successful!"));
toast.setAutohide(true);
toast.setDelay(3000);
\`\`\``;
}
